import React from 'react';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
//import BrowserUtil from '../../util/BrowserUtil';
import Landing from './Landing';
import $ from 'jquery';
import HmEventRegistry from '../../model/HmEventRegistry';

class ContestLanding extends Landing{
	
	constructor(props) {
		super(props);

		this.state = {	
			visible:false,
			topicListPlaceHolder:"",
			upgradenow:false
			//loggedIn: true  //Overriding to reduce repeated componentMounts
		};


		this.childComponent = null;
		this.childComponentName = null;

		this.userNameUpdateEvent = this.userNameUpdateEvent.bind(this);
		this.updateImage = this.updateImage.bind(this);
		this.sideBarDropdownChange = this.sideBarDropdownChange.bind(this);
		this.routingMenus = this.routingMenus.bind(this);
		this.loginStoreKey="PLP_LOGIN_INFO";	 
		this.homeDropDownKey = "homeDropdown";
		this.gradeStore = null;

		this.renderSidebar=this.renderSidebar.bind(this);
	};

	setChild(childComp,childName){
		this.childComponent = childComp; 
		this.childComponentName = childName;
	} 

	componentDidMount(){
		this.alignDomain();
		//this.appendCSS("/contests/contest.css");
		this.sessionCheck();
		this.loginTracking();
		
		let contestGrp = this.getSelectedContestGroup();
		if(contestGrp){
			this.setTitle(this.rb(contestGrp));
			this.setMeta(contestGrp);
			this.setHeading(contestGrp);
		}

		HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	} 

	isValidContest(contestGrpId=null){
		if(!contestGrpId){
			contestGrpId = localStorage.getItem("contestType");
		}

		if(contestGrpId){
			return window.all_contests.includes(contestGrpId);
		}

		return false;			
	}

	getSelectedContestGroup(){
		let contestGrpParam = (this.props.match && this.props.match.params && this.props.match.params.contestGrpId) ? this.props.match.params.contestGrpId : localStorage.getItem("contestType");

		if(contestGrpParam && this.isValidContest(contestGrpParam)){
			localStorage.setItem("contestType",contestGrpParam);
		}else{
			localStorage.setItem("contestType",window.default_contest);
		}

		return localStorage.getItem("contestType");
	}

	getAccessIdsforProducts(){
		var accessIds = [];
		var prodAccess = ["PLP|REVISION|TAKE","PLP|LESSON|VIEW"];
		var user = this.getUser();

		if(user.getAccessMap()){
			for(var i in user.getAccessMap()){
				if(prodAccess.indexOf(user.getAccessMap()[i]) >= 0){
					accessIds.push(i);
				}
			}
		}

		return accessIds;
	}

	getClassIdforAccessCount(classId){
		var accessIds = this.getAccessIdsforProducts();
		var user = this.getUser();

		var counter = 0;
		if(user.getPermissions() && accessIds){
			//var classId = 4;

			for(var i in user.getPermissions()){
				try{
					if(accessIds.indexOf(i) && user.getPermissions()[i].indexOf(classId)){
						counter ++;
					}
				}catch(e){
				}		
			}

		}

		return counter;	
	}



	routingMenus(value){
		//console.log("routing  == ",this.props.history," ::: ",value);
		if(this.props.history){
			this.props.history.push(value);
		}else{
			window.location.href = value;
		}
	}
	loginTracking(){
		try{
			var loginInfo = BrowserStorageUtil.getStoredSessionItem(this.loginStoreKey);		
			//console.log("loginInfo:::",loginInfo);
			if(loginInfo){
				this.initiateTrack("login",JSON.parse(loginInfo));
				BrowserStorageUtil.removeSessionItem(this.loginStoreKey);
			}
		}catch(e){}
	}
	userNameUpdateEvent(username){	
		this.sidebarComponent.updateUserName(username);
	}
	
	updateImage(imageUrl){
		if(imageUrl){
			this.sidebarComponent.setCurrentImage(imageUrl);
		}else{
			this.sidebarComponent.deleteCurrentImage();
		}
	}

	sideBarDropdownChange(selectedGradeOption,selectedProductOption,comboNamesLoaded,state,isProductClicked){
		console.log("selected product:::",selectedGradeOption," :::: " ,selectedProductOption);
		if( this.childComponent && this.childComponent.assignStateFromParent){
			this.childComponent.selectedProductOption = selectedProductOption;
			this.childComponent.selectedGradeOption = selectedGradeOption;
			this.childComponent.comboNamesLoaded = comboNamesLoaded;
			this.childComponent.assignStateFromParent(state);
			
			if(state.noProducts == false){
				this.childComponent.getTopicList();
			}
		}else{
			if(this.childComponentName == "DASHBOARD" && !isProductClicked){
				this.childComponent.gradeDropdownChange(selectedGradeOption);
			}
		}
		
		// this.setState({upgradenow:false});
	}	

	renderSidebar(){
		var mindstretcher=true;
		var me=this;

		let SideBarComp = me.getComponent("Sidebar");
		return (
			<SideBarComp onRef={ref => (me.sidebarComponent = ref)} myProps={me.props} sideBarDropdownChange={me.sideBarDropdownChange} childComponentName={me.childComponentName} routingMenus={me.routingMenus}/>
			)
	}

	render(subComponent) {
		{$(".page-content .content-inner").addClass("contest_content")}	
		return super.render(subComponent)

	}
}

export default ContestLanding;



// WEBPACK FOOTER //
// ./src/views/common/ContestLanding.js